import React__default, { useEffect } from 'react';
import ReactDOM__default from 'react-dom';
import { getPortalDOM } from '../Utils/portaldom.util.js';

function Portal(_a) {
    var children = _a.children, domElement = _a.domElement;
    var _b = React__default.useState(null), portalState = _b[0], setPortalState = _b[1];
    useEffect(function () {
        if (domElement) {
            setPortalState(domElement);
            return;
        }
        setPortalState(getPortalDOM());
    }, [domElement]);
    return (React__default.createElement(React__default.Fragment, null, portalState && (React__default.createElement(DOMPortal, { children: children, portalState: portalState }))));
}
function DOMPortal(_a) {
    var children = _a.children, portalState = _a.portalState;
    return ReactDOM__default.createPortal(children, portalState);
}

export { Portal as default };
//# sourceMappingURL=Portal.js.map
